module.exports = __webpack_public_path__ + "img/brackets-slash.1d94faad.svg";